import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./main.scss";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "./Components/Layouts";
import "bootstrap/dist/css/bootstrap.css";
import "antd-css-utilities/utility.min.css";
import "bootstrap/dist/css/bootstrap.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<AppLayout />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
